import React from 'react'
import {Button, Comment, Divider, Space, Tag} from 'antd';
import AiChatAnswer from './AiChatAnswer'
import PropTypes from "prop-types";
import UserAvatar from './UserAvatar';
import {HashIcon, InboxIcon, UpRightArrowOutlined} from '@web/assets/icons';
import JsonString from './JsonString';
import Day from './Day';

const safeParse = (value) => {
  try {
    return JSON.parse(value);
  } catch (e) {
    console.error("safeParse:error:", e);
    return value;
  }
}

ChatResponse.propTypes = {
  chat: PropTypes.object.isRequired,
  chatIndex: PropTypes.number.isRequired,
}

export default function ChatResponse(props) {
  return <div className={`brainstorm-message left${props.chat.type === "ai-task" ? " ai-task-wrapper" : ""}`}>
    <Space direction="vertical" style={{width: "100%"}}>
      {props.chat.type === "ai-task" && <Divider orientation="left" dashed />}
      {props.chat.type === "ai-task" &&
        <Comment
          datetime={<Day ts={props.chat.createdTs}/>}
          author={props.chat.agentId}
          avatar={<UserAvatar icon={<InboxIcon />} />}
          content={<span className="font-lg ai-text">{props.chat.prompt} <span className="text-color muted">#agenttask</span></span>}
          actions={[
            props.chat.threadPaths?.length ? <Button className="icon-btn icon-right" shape="round">{props.chat?.answers?.length ? `${props.chat?.answers?.length} |` : ""} Thread <UpRightArrowOutlined /></Button> : null,
            // <Button shape="round">Collapse <MinusOutlined/></Button>,
          ]}
        />}
      <div className="sub-message-group-wrapper">
        {props.chat.answers?.map((answer, answerIndex) => {
          if (!answer.text && answer.toolCalls) {
            const args = safeParse(answer.toolCalls[0].function?.arguments);
            return <div key={answerIndex} style={{margin: "12px 0 12px 18px", padding: "1px 40px 1px 18px", borderRadius: "80px"}} className="fat-chip large">
              <Comment
                avatar={<UserAvatar size={26} icon={<HashIcon size={14} className="muted-icon" />} />}
                content={
                  <span>{args.request || args.output || args.reason || args?.info?.[0]?.name || args?.indexNames?.[0] || <JsonString text={answer.toolCalls[0].function?.arguments} />}</span>}
              />
              {/*<span className="fat-chip primary">{answer.toolCalls[0].function?.name}</span>*/}
            </div>;
          }
          return <AiChatAnswer
            key={answerIndex}
            agentId={answer.agentId}
            chatIndex={props.chatIndex}
            answerIndex={answerIndex}
            text={answer.text}
            toolCalls={answer.toolCalls}
            toolResults={answer.toolResults}
            charts={answer.charts}
          />;
        })}
      </div>
    </Space>
  </div>
}
